module.exports = __webpack_public_path__ + "img/sign-up-img.5c56658.png";